"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticSearchServiceNS = void 0;
var ElasticSearchServiceNS;
(function (ElasticSearchServiceNS) {
    ElasticSearchServiceNS.ELASTIC_SEARCH_SERVICE_ID = Symbol.for("ElasticSearchService");
})(ElasticSearchServiceNS = exports.ElasticSearchServiceNS || (exports.ElasticSearchServiceNS = {}));
//# sourceMappingURL=elastic-search.types.js.map